import {
  Header,
  HeroSection,
  EarnPointsSection,
  ContestantSection,
  TwitchCTASection,
  SocialSection,
  MerchSection,
  Footer,
  BackgroundEffects
} from '../components/landing';

const Home = () => {
  return (
    <div className="min-h-screen game-show-bg">
      <BackgroundEffects />
      <Header />
      <HeroSection />
      <EarnPointsSection />
      <ContestantSection />
      <TwitchCTASection />
      <SocialSection />
      <MerchSection />
      <Footer />
    </div>
  );
};

export default Home;
